import React, { forwardRef } from 'react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
  options: SelectOption[];
  placeholder?: string;
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label,
  error,
  helperText,
  options,
  placeholder,
  className = '',
  id,
  ...props
}, ref) => {
  const selectId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-198">
        {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-199">
            {label}
          </label>}
        <select ref={ref} id={selectId} className={`
            w-full px-3 py-2 border rounded-lg text-gray-900
            bg-white
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
            disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed
            ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'}
            ${className}
          `} aria-invalid={error ? 'true' : 'false'} aria-describedby={error ? `${selectId}-error` : helperText ? `${selectId}-helper` : undefined} {...props} data-id="element-200">
          {placeholder && <option value="" disabled data-id="element-201">
              {placeholder}
            </option>}
          {options.map(option => <option key={option.value} value={option.value} data-id="element-202">
              {option.label}
            </option>)}
        </select>
        {error && <p id={`${selectId}-error`} className="mt-1 text-sm text-red-600" data-id="element-203">
            {error}
          </p>}
        {helperText && !error && <p id={`${selectId}-helper`} className="mt-1 text-sm text-gray-500" data-id="element-204">
            {helperText}
          </p>}
      </div>;
});
Select.displayName = 'Select';